import React, { HTMLProps } from 'react';
import { Link, LinkProps } from '@modernhealth/vital-components';

export type ExternalLinkProps = HTMLProps<HTMLAnchorElement> &
    Omit<LinkProps, 'children'> & {
        openInNewTab?: boolean;
    };

export const ExternalLink: React.FC<ExternalLinkProps> = ({
    children,
    href,
    className,
    rel = 'noopener noreferrer',
    openInNewTab,
    ...linkProps
}) => (
    <Link className={className}>
        <a href={href} {...linkProps} rel={rel} {...(openInNewTab ? { target: '_blank' } : {})}>
            {children}
        </a>
    </Link>
);
